import en from "./en";
const nl = {
  ...en,
  nav: {
    home: "Home",
    about: "De Alliantie",
    markets: "Markten",
    services: "Diensten",
    partners: "Partners",
    manufacturers: "Voor Fabrikanten",
    news: "Nieuws",
    contact: "Contact",
    partner_cta: "Word Partner",
  },
  hero: {
    eyebrow: "European Electric Mobility Alliance",
    title_line1: "Het Europese distributieplatform",
    title_line2: "voor elektrische mobiliteit",
    subtitle: "Wij verbinden fabrikanten met het meest ervaren distributienetwerk van Europa. Wij importeren niet zomaar voertuigen. Wij bouwen merken.",
    cta_primary: "Word Partner",
    cta_secondary: "Ontdek de Alliantie",
    scroll: "Scrol om te ontdekken",
  },
  cta_final: {
    eyebrow: "Strategisch Partnerschap",
    title: "Klaar om Europa te veroveren?",
    subtitle: "Werk samen met EEMA en profiteer van een gevestigd commercieel platform in de meest strategische Europese markten voor elektrische mobiliteit.",
    button: "Vraag een gesprek aan",
  },
};
export default nl;
